import { warehouseIOType } from "types/enum";
import { InventoryRemittanceForm } from "./InventoryRemittance/InventoryRemittanceForm";
import { InventoryReceiptForm } from './InventoryReceipt/InventoryReceiptForm'
import { InventoryBalancingForm } from "./InventoryBalancing/InventoryBalancingForm";
import { TransferReceiptForm } from "./TransferReceipt/TransferReceiptForm";
import { ReturnRemittanceForm } from "./ReturnRemittance/ReturnRemittanceForm";
import { TransferRemittanceForm } from "./TransferRemittance/TransferRemittanceForm";
import { DirectDeliveryForm } from "./DirectDelivery/DirectDeliveryForm";
import { ReturnReceiptForm } from "./ReturnReciept/ReturnReceiptForm";


const warehouseIOForms = {
    [warehouseIOType.InventoryRemittance]: InventoryRemittanceForm,
    [warehouseIOType.InventoryReceipt]: InventoryReceiptForm,
    [warehouseIOType.InventoryBalancing]: InventoryBalancingForm,
    [warehouseIOType.TransferReceipt]: TransferReceiptForm,
    [warehouseIOType.ReturnRemittance]: ReturnRemittanceForm,
    [warehouseIOType.TransferRemittance]: TransferRemittanceForm,
    [warehouseIOType.DirectDelivery]:DirectDeliveryForm,
    [warehouseIOType.ReturnReceipt]:ReturnReceiptForm,
  };
interface WarehouseIOTypeFormProps {
    type: any;//string => exmaple InventoryRemittance
    warehouseIoEnaumType?:any//enum => exmaple InventoryRemittance is enum 3 so result is 3
    onHide: () => void;
    reload: () => void;
    [key: string]: any; 
  }
  
  const WarehouseIOTypeForm: React.FC<WarehouseIOTypeFormProps> = ({ type,warehouseIoEnaumType, ...props }) => {
    const FormComponent = warehouseIOForms[warehouseIoEnaumType] || null;
    return FormComponent ? <FormComponent {...props} /> : <div></div>;
  };
  
  export default WarehouseIOTypeForm;
  